import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientBenefits = () => {
  const benefits = [
    {
      icon: 'Shield',
      title: 'Legal Protection',
      description: 'Comprehensive legal protection for workplace rights and interests, ensuring compliance with all relevant employment laws and regulations.'
    },
    {
      icon: 'Users',
      title: 'Expert Consultation',
      description: 'Access to experienced employment law attorneys who understand the complexities of Kenya\'s labor landscape and workplace dynamics.'
    },
    {
      icon: 'TrendingUp',
      title: 'Strategic Guidance',
      description: 'Strategic advice on employment policies, procedures, and best practices that protect your interests while fostering positive workplace relationships.'
    },
    {
      icon: 'Clock',
      title: 'Timely Resolution',
      description: 'Efficient handling of employment matters with focus on timely resolution to minimize disruption to business operations and personal lives.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            How We Help
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Our employment law services provide comprehensive support for both employers and employees, ensuring fair and compliant workplace practices.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
                <Icon name={benefit.icon} size={24} color="white" strokeWidth={2} />
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                  {benefit.title}
                </h3>
                <p className="text-text-secondary leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Process Overview */}
        <div className="bg-gradient-to-br from-surface/20 to-primary/5 rounded-2xl p-8 border border-primary/10">
          <h3 className="text-2xl font-heading font-semibold text-text-primary mb-6 text-center">
            Our Consultation Process
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="MessageCircle" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Initial Consultation
              </h4>
              <p className="text-text-secondary">
                Discuss your employment law needs and receive preliminary advice on your situation.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-accent rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Search" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Case Analysis
              </h4>
              <p className="text-text-secondary">
                Thorough analysis of your case with strategic recommendations for the best course of action.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="CheckCircle" size={24} color="white" strokeWidth={2} />
              </div>
              <h4 className="text-lg font-heading font-semibold text-text-primary mb-2">
                Resolution
              </h4>
              <p className="text-text-secondary">
                Implementation of legal solutions with ongoing support until successful resolution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientBenefits;